/** @file Finds a registered command by name in the generated registry (the ApplyEnv lookup). */
import type { CommandDef } from './defineCommand';
import { COMMANDS } from './registry.gen';

const BY_NAME = new Map<string, CommandDef<unknown>>(COMMANDS.map((c): [string, CommandDef<unknown>] => [c.name, c]));

/** The registered command called `name`, or undefined (applyCommand turns that into NOT_FOUND). */
export function lookupCommand(name: string): CommandDef<unknown> | undefined {
  return BY_NAME.get(name);
}
